import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import t5 from '../../../assets/images/t5.png';
import t6 from '../../../assets/images/t6.png';
import t8 from '../../../assets/images/t8.png';
import t9 from '../../../assets/images/t9.png';
import t10 from '../../../assets/images/t10.png';
import t11 from '../../../assets/images/t11.png';
import w3 from '../../../assets/images/w3.png';
import c30 from '../../../assets/images/c30.png';
import c40 from '../../../assets/images/c40.png';
import s100 from '../../../assets/images/s100.png';

import { X, ChevronDown, ChevronRight } from 'lucide-react';

export default function MobileSitemap({ isOpen, onClose }) {
  const navigate = useNavigate();
  const [openMenu, setOpenMenu] = useState(null);
  const [openSubMenu, setOpenSubMenu] = useState(null);

  const handleMenuClick = (menuIndex) => {
    if (openMenu === menuIndex) {
      setOpenMenu(null);
      setOpenSubMenu(null);
    } else {
      setOpenMenu(menuIndex);
      setOpenSubMenu(null);
    }
  };

  const handleSubMenuClick = (subMenuIndex) => {
    if (openSubMenu === subMenuIndex) {
      setOpenSubMenu(null);
    } else {
      setOpenSubMenu(subMenuIndex);
    }
  };

  const handleLinkClick = (url) => {
    navigate(url);
    onClose();
  };

  const handleClose = () => {
    setOpenMenu(null);
    setOpenSubMenu(null);
    onClose();
  };

  return (
    <div id="sitemap" className={`sitemap ${isOpen ? 'show' : ''}`}>
      <div className="close_btn" onClick={handleClose}>
        <X />
      </div>
      <div className="st_box">
        {/* 크림봇 메뉴 */}
        <div className={`st_menu ${openMenu === 0 ? 'on' : ''}`}>
          <p
            className="prt-bold fs-20 fc-black1 row-flex-center gap-10"
            onClick={() => handleMenuClick(0)}
          >
            <ChevronDown className="chevronIcon" /> 크림봇
          </p>
          <ul style={{ display: openMenu === 0 ? 'block' : 'none' }}>
            <li>
              <a
                href="/sub1_1"
                className="fs-18 fc-black1 prt-medium row-flex-center gap-10"
                onClick={(e) => {
                  e.preventDefault();
                  handleLinkClick('/sub1_1');
                }}
              >
                <ChevronRight className="chevronIcon" /> 회사소개
              </a>
            </li>
            <li>
              <a
                href="/sub1_2"
                className="fs-18 fc-black1 prt-medium row-flex-center gap-10"
                onClick={(e) => {
                  e.preventDefault();
                  handleLinkClick('/sub1_2');
                }}
              >
                <ChevronRight className="chevronIcon" /> 연혁
              </a>
            </li>
            <li>
              <a
                href="/sub1_3"
                className="fs-18 fc-black1 prt-medium row-flex-center gap-10"
                onClick={(e) => {
                  e.preventDefault();
                  handleLinkClick('/sub1_3');
                }}
              >
                <ChevronRight className="chevronIcon" /> 오시는길
              </a>
            </li>
          </ul>
        </div>

        {/* 제품소개 메뉴 */}
        <div className={`st_menu ${openMenu === 1 ? 'on' : ''}`}>
          <p
            className="prt-bold fs-20 fc-black1 row-flex-center gap-10"
            onClick={() => handleMenuClick(1)}
          >
            <ChevronDown className="chevronIcon" /> 제품소개
          </p>
          <ul style={{ display: openMenu === 1 ? 'block' : 'none' }}>
            {/* 서빙로봇 */}
            <li className={`sub_menu ${openSubMenu === 'serving' ? 'on' : ''}`}>
              <p
                className="fs-18 fc-black1 prt-medium sub_menu_title row-flex-center gap-10"
                onClick={() => handleSubMenuClick('serving')}
              >
                <ChevronRight className="chevronIcon" /> 서빙로봇
              </p>
              <ul
                className="third_menu"
                style={{
                  display: openSubMenu === 'serving' ? 'block' : 'none',
                }}
              >
                <li>
                  <a
                    href="#"
                    className="fs-16 fc-black1 prt-regular third_menu_link"
                    onClick={(e) => {
                      e.preventDefault();
                      handleLinkClick('/sub2_1_1');
                    }}
                  >
                    <div className="product_info">
                      <img src={t10} alt="T10" className="product_thumb" />
                      <span>T10</span>
                    </div>
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="fs-16 fc-black1 prt-regular third_menu_link"
                    onClick={(e) => {
                      e.preventDefault();
                      handleLinkClick('/sub2_1_2');
                    }}
                  >
                    <div className="product_info">
                      <img src={t8} alt="T8" className="product_thumb" />
                      <span>T8</span>
                    </div>
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="fs-16 fc-black1 prt-regular third_menu_link"
                    onClick={(e) => {
                      e.preventDefault();
                      handleLinkClick('/sub2_1_3');
                    }}
                  >
                    <div className="product_info">
                      <img src={t9} alt="T9" className="product_thumb" />
                      <span>T9</span>
                    </div>
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="fs-16 fc-black1 prt-regular third_menu_link"
                    onClick={(e) => {
                      e.preventDefault();
                      handleLinkClick('/sub2_1_4');
                    }}
                  >
                    <div className="product_info">
                      <img src={t11} alt="T11" className="product_thumb" />
                      <span>T11</span>
                    </div>
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="fs-16 fc-black1 prt-regular third_menu_link"
                    onClick={(e) => {
                      e.preventDefault();
                      handleLinkClick('/sub2_1_5');
                    }}
                  >
                    <div className="product_info">
                      <img src={t6} alt="T6" className="product_thumb" />
                      <span>T6</span>
                    </div>
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="fs-16 fc-black1 prt-regular third_menu_link"
                    onClick={(e) => {
                      e.preventDefault();
                      handleLinkClick('/sub2_1_5');
                    }}
                  >
                    <div className="product_info">
                      <img src={t5} alt="T5" className="product_thumb" />
                      <span>T5</span>
                    </div>
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="fs-16 fc-black1 prt-regular third_menu_link"
                    onClick={(e) => {
                      e.preventDefault();
                      handleLinkClick('/sub2_1_7');
                    }}
                  >
                    <div className="product_info">
                      <img src={w3} alt="W3" className="product_thumb" />
                      <span>W3</span>
                    </div>
                  </a>
                </li>
              </ul>
            </li>

            {/* 물류로봇 */}
            <li
              className={`sub_menu ${openSubMenu === 'logistics' ? 'on' : ''}`}
            >
              <p
                className="fs-18 fc-black1 prt-medium sub_menu_title  row-flex-center gap-10"
                onClick={() => handleSubMenuClick('logistics')}
              >
                <ChevronRight className="chevronIcon" /> 물류로봇
              </p>
              <ul
                className="third_menu"
                style={{
                  display: openSubMenu === 'logistics' ? 'block' : 'none',
                }}
              >
                <li>
                  <a
                    href="#"
                    className="fs-16 fc-black1 prt-regular third_menu_link"
                    onClick={(e) => {
                      e.preventDefault();
                      handleLinkClick('/sub2_2');
                    }}
                  >
                    <div className="product_info">
                      <img src={s100} alt="S100" className="product_thumb" />
                      <span>S100</span>
                    </div>
                  </a>
                </li>
              </ul>
            </li>

            {/* 청소로봇 */}
            <li
              className={`sub_menu ${openSubMenu === 'cleaning' ? 'on' : ''}`}
            >
              <p
                className="fs-18 fc-black1 prt-medium sub_menu_title  row-flex-center gap-10"
                onClick={() => handleSubMenuClick('cleaning')}
              >
                <ChevronRight className="chevronIcon" /> 청소로봇
              </p>
              <ul
                className="third_menu"
                style={{
                  display: openSubMenu === 'cleaning' ? 'block' : 'none',
                }}
              >
                <li>
                  <a
                    href="#"
                    className="fs-16 fc-black1 prt-regular third_menu_link"
                    onClick={(e) => {
                      e.preventDefault();
                      handleLinkClick('/sub2_3_1');
                    }}
                  >
                    <div className="product_info">
                      <img src={c30} alt="C30" className="product_thumb" />
                      <span>C30</span>
                    </div>
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="fs-16 fc-black1 prt-regular third_menu_link"
                    onClick={(e) => {
                      e.preventDefault();
                      handleLinkClick('/sub2_3_2');
                    }}
                  >
                    <div className="product_info">
                      <img src={c40} alt="C40" className="product_thumb" />
                      <span>C40 </span>
                    </div>
                  </a>
                </li>
              </ul>
            </li>

            {/* 마케팅 */}
            <li>
              <a
                href="#"
                className="fs-18 fc-black1 prt-medium row-flex-center gap-10"
                onClick={(e) => {
                  e.preventDefault();
                  handleLinkClick('/sub2_4');
                }}
              >
                <ChevronRight className="chevronIcon" /> 마케팅
              </a>
            </li>

            {/* 매장통합관리솔루션 */}
            <li>
              <a
                href="#"
                className="fs-18 fc-black1 prt-medium row-flex-center gap-10"
                onClick={(e) => {
                  e.preventDefault();
                  handleLinkClick('/sub2_5');
                }}
              >
                <ChevronRight className="chevronIcon" /> 매장통합관리솔루션
              </a>
            </li>
          </ul>
        </div>

        {/* 이벤트 메뉴 */}
        <div className={`st_menu ${openMenu === 2 ? 'on' : ''}`}>
          <p
            className="prt-bold fs-20 fc-black1 row-flex-center gap-10"
            onClick={() => handleMenuClick(2)}
          >
            <ChevronDown className="chevronIcon" /> 이벤트/소식
          </p>
          <ul style={{ display: openMenu === 2 ? 'block' : 'none' }}>
            <li>
              <a
                href="#"
                className="fs-18 fc-black1 prt-medium row-flex-center gap-10"
                onClick={(e) => {
                  e.preventDefault();
                  handleLinkClick('/sub3_1');
                }}
              >
                <ChevronRight className="chevronIcon" /> 크림봇 EVENT
              </a>
            </li>
            <li>
              <a
                href="#"
                className="fs-18 fc-black1 prt-medium row-flex-center gap-10"
                onClick={(e) => {
                  e.preventDefault();
                  handleLinkClick('/sub3_2');
                }}
              >
                <ChevronRight className="chevronIcon" /> 뉴스/소식
              </a>
            </li>
          </ul>
        </div>

        {/* 설치사례 메뉴 */}
        <div className={`st_menu ${openMenu === 3 ? 'on' : ''}`}>
          <p
            className="prt-bold fs-20 fc-black1 row-flex-center gap-10"
            onClick={() => handleMenuClick(3)}
          >
            <ChevronDown className="chevronIcon" /> 설치사례
          </p>
          <ul style={{ display: openMenu === 3 ? 'block' : 'none' }}>
            <li>
              <a
                href="#"
                className="fs-18 fc-black1 prt-medium row-flex-center gap-10"
                onClick={(e) => {
                  e.preventDefault();
                  handleLinkClick('/sub4_1');
                }}
              >
                <ChevronRight className="chevronIcon" /> 서빙로봇
              </a>
            </li>
            <li>
              <a
                href="#"
                className="fs-18 fc-black1 prt-medium row-flex-center gap-10"
                onClick={(e) => {
                  e.preventDefault();
                  handleLinkClick('/sub4_2');
                }}
              >
                <ChevronRight className="chevronIcon" /> 청소로봇
              </a>
            </li>
            <li>
              <a
                href="#"
                className="fs-18 fc-black1 prt-medium row-flex-center gap-10"
                onClick={(e) => {
                  e.preventDefault();
                  handleLinkClick('/sub4_3');
                }}
              >
                <ChevronRight className="chevronIcon" /> 인터뷰
              </a>
            </li>
          </ul>
        </div>

        {/* 제휴문의 메뉴 */}
        <div className={`st_menu ${openMenu === 4 ? 'on' : ''}`}>
          <p
            className="prt-bold fs-20 fc-black1 row-flex-center gap-10"
            onClick={() => handleMenuClick(4)}
          >
            <ChevronDown className="chevronIcon" /> 제휴문의
          </p>
          <ul style={{ display: openMenu === 4 ? 'block' : 'none' }}>
            <li>
              <a
                href="#"
                className="fs-18 fc-black1 prt-medium row-flex-center gap-10"
                onClick={(e) => {
                  e.preventDefault();
                  handleLinkClick('/sub5_1');
                }}
              >
                <ChevronRight className="chevronIcon" /> 제휴업체문의하기
              </a>
            </li>
          </ul>
        </div>

        {/* 고객센터 메뉴 */}
        <div className={`st_menu ${openMenu === 5 ? 'on' : ''}`}>
          <p
            className="prt-bold fs-20 fc-black1 row-flex-center gap-10"
            onClick={() => handleMenuClick(5)}
          >
            <ChevronDown className="chevronIcon" /> 고객센터
          </p>
          <ul style={{ display: openMenu === 5 ? 'block' : 'none' }}>
            <li>
              <a
                href="#"
                className="fs-18 fc-black1 prt-medium row-flex-center gap-10"
                onClick={(e) => {
                  e.preventDefault();
                  handleLinkClick('/sub6_1');
                }}
              >
                <ChevronRight className="chevronIcon" /> 제품문의
              </a>
            </li>
            <li>
              <a
                href="#"
                className="fs-18 fc-black1 prt-medium row-flex-center gap-10"
                onClick={(e) => {
                  e.preventDefault();
                  handleLinkClick('/sub6_2');
                }}
              >
                <ChevronRight className="chevronIcon" /> 자가관리방법
              </a>
            </li>
          </ul>
        </div>

        {/* 크림렌탈 메뉴 */}
        <div className={`st_menu ${openMenu === 5 ? 'on' : ''} ml-3`}>
          <a
            target="_blank"
            href="http://creamrental.com"
            className="prt-bold fs-20 fc-black1 row-flex-center gap-10"
          >
            크림렌탈
          </a>
        </div>
      </div>
    </div>
  );
}
